export const threeDays = 4320;
export const twoDays = 2880;
export const oneDay = 1440;
export const twelfthHours = 720;
export const oneHour = 60;
export const nullValue = 0;
